import React, { useEffect, useState } from "react";
import MobileSearchBarPage from "./mobileSearchPage";
import { Link, useNavigate } from "react-router-dom";
import LoginModal from "../main/loginModal/LoginModal";

const MobileSearchTabs = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [userProfile, setUserProfile] = useState();
  const [editProfileClicked, setEditProfileCliked] = useState(false);

  const accessToken = localStorage.getItem("@user");

  const navigate = useNavigate();

  const [isVisible, setIsVisible] = useState(accessToken ? false : true);
  const [mobileSearchBar, setMobileSearchBar] = useState(false);
  const [topPosition, setTopPosition] = useState(50);


  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const decrement = 1300 / steps;

    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - decrement;
        });
      }, intervalTime);
    } 

    return () => clearInterval(interval);
  }, [isVisible]);

    useEffect(() => {
      // Check screen width
      if (window.innerWidth > 768) {
        // Redirect to "/" if on desktop
        navigate("/");
      }
    }, [navigate]);
  

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="mobile-search ">
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <div className="mob-search-wrapper">
        <div className="mob-search-where">
          <div className="drop_down moble-search-where relative">
            {/* Close Button */}
            <div className="flex  justify-start px-4 mb-4">
              <div className="close-btn-div-search-mob">
                <div className="close-btn-wrapper">
                  <Link  onClick={() => navigate(-1)} className="close-btn-mob-search w-embed pt-5">
                    <svg
                      width="34"
                      height="34"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 122.881 122.88"
                    >
                      <g>
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          fill="grey"
                          d="M61.44,0c33.933,0,61.441,27.507,61.441,61.439 c0,33.933-27.508,61.44-61.441,61.44C27.508,122.88,0,95.372,0,61.439C0,27.507,27.508,0,61.44,0L61.44,0z M81.719,36.226 c1.363-1.363,3.572-1.363,4.936,0c1.363,1.363,1.363,3.573,0,4.936L66.375,61.439l20.279,20.278c1.363,1.363,1.363,3.573,0,4.937 c-1.363,1.362-3.572,1.362-4.936,0L61.44,66.376L41.162,86.654c-1.362,1.362-3.573,1.362-4.936,0c-1.363-1.363-1.363-3.573,0-4.937 l20.278-20.278L36.226,41.162c-1.363-1.363-1.363-3.573,0-4.936c1.363-1.363,3.573-1.363,4.936,0L61.44,56.504L81.719,36.226 L81.719,36.226z"
                        />
                      </g>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MobileSearchBarPage />
    </section>
  );
};

export default MobileSearchTabs;
